import {
  Alert,
  Box,
  Breadcrumbs,
  Card,
  CardContent,
  Chip,
  Snackbar,
  Tab,
  Tabs,
  Typography
} from '@mui/material';
import {
  keywordOverviewCss,
  snackBar
} from '../keywordResearch/keywordOverview/keywordOverviewCSS';
import { lazy, useEffect, useRef, useState } from 'react';
import { taskListCSS } from '../seotask/SEOTaskCSS';
import { keywordResearchDashBoardCss } from '../keywordResearch/keywordResearchCSS';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { GMBTutorialLinks, localSeoTexts } from './localSeoTexts';
import { LocalSeoAllSx } from './localSeoCss';
import { LocalSeoProgress } from './LocalSeoProgress';
import { useDispatch, useSelector } from 'react-redux';
import {
  setBusinessNamesData,
  setIsConnectionFlow,
  setLocationListResponse,
  setLocationsDetailsLoader,
  setReduxFilteredLocationsData,
  setReduxLocationsData,
  setSelectedAccountId,
  setSelectedBusinessAccountId,
  setSelectedBusinessName,
  setSelectedBusinessNameFilter,
  setSelectedLocalSeoTask,
  setSelectedLocationId
} from 'src/redux/localSeo';
import {
  setIsAgencyUpgrade,
  setLocalSeoSection
} from 'src/redux/keywordResearch';
import {
  enterpriseDropdownBusinessesLimit,
  keywordOverviewTexts,
  localSeoSignupSourceSqsp,
  localseoSignupSqspFlow,
  paths,
  SEOSpaceLocal
} from 'src/common/config/TextMessage';
import { useNavigate } from 'react-router';
import {
  getCreditDetails,
  getLocations,
  localSeoTasks
} from 'src/common/Scraper';
import {
  getCookie,
  isLocalSeoUser,
  localStorageMethod,
  openNewTab
} from 'src/common/config/FunctionHelper';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { RootState } from 'src/redux/store';
import { Helmet } from 'react-helmet-async';
import { KeywordTrackingAllTexts } from '../keywordResearch/keywordTracking/KeywordTrackingAllTexts';
import {
  getLocalSeoBusinessId,
  getLocalSeoId,
  setLocalSeoBusinessId,
  setLocalSeoId,
  updateSearchesDetailsAndLimits
} from 'src/common/config/FunctionHelperPartTwo';
import { useBrowserType } from 'src/hooks/useBrowserType';
import { useChromeBrowserBanner } from 'src/hooks/useChromeBrowserBanner';
import Loader from 'src/common/config/Loader';
// Named Exports
const LocalSeoCommonLoader = Loader(
  lazy(() =>
    import('./LocalSeoCommonLoader').then((module) => ({
      default: module.LocalSeoCommonLoader
    }))
  )
);
const SelectedLocalSeoTask = Loader(
  lazy(() =>
    import('./SelectedLocalSeoTask').then((module) => ({
      default: module.SelectedLocalSeoTask
    }))
  )
);
const UpgradeToAgency = Loader(
  lazy(() =>
    import('../keywordResearch/keywordTracking/UpgradeToAgency').then(
      (module) => ({ default: module.UpgradeToAgency })
    )
  )
);
const ConnectBusinessProfileModal = Loader(
  lazy(() =>
    import('./ConnectBusinessProfileModal').then((module) => ({
      default: module.ConnectBusinessProfileModal
    }))
  )
);
const NewCommonChromeExtensionModal = Loader(
  lazy(() =>
    import('src/common/NewCommomChromeExtensionModal').then((module) => ({
      default: module.NewCommonChromeExtensionModal
    }))
  )
);

// Default Export
const BuySlotsCommonModal = Loader(
  lazy(() => import('src/common/LocalSeoCommonComponents/BuySlotsCommonModal'))
);
import { BusinessProfileSelector } from './BusinessProfileSelector';

export const RecommendActionsCard = () => {
  const [value, setValue] = useState('critical');
  const [googleAuthText, setGoogleAuth] = useState(null);
  const [loader, setLoader] = useState(null);
  const [criticalSuggestions, setCriticalSuggestions] = useState([]);
  const [recommendedSuggestions, setRecommendedSuggestions] = useState([]);
  const [optionalSuggestions, setOptionalSuggestions] = useState([]);
  const [completedSuggestions, setCompletedSuggestions] = useState([]);
  const [openTask, setOpenTask] = useState(false);
  const [allTasks, setAllTasks] = useState([]);
  const [criticalCount, setCriticalCount] = useState(null);
  const [recommendedCount, setRecommendedCount] = useState(null);
  const [optionalCount, setOptionalCount] = useState(null);
  const [completedCount, setCompletedCount] = useState(null);
  const [totalCount, setTotalCount] = useState(null);
  const [countProgress, setCountProgress] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [creditLoader, setCreditLoader] = useState(true);
  const [snackBarData, setSnackBarData]: any = useState(null);
  let selectedBusinessName: any =
    useSelector((state: RootState) => state.localSeo.selectedBusinessName) ??
    '';
  const loaderRedux =
    useSelector((state: RootState) => state.siteAudit.loader) ?? true;
  let locationsData =
    useSelector((state: RootState) => state.localSeo.reduxLocationsData) ??
    null;
  let reduxFilteredLocationsData =
    useSelector(
      (state: RootState) => state.localSeo.reduxFilteredLocationsData
    ) ?? null;
  const match = reduxFilteredLocationsData?.find(
    (location) => location?.title === selectedBusinessName
  );
  const localStorageSeoId = getLocalSeoId();
  const squareSpaceSiteId = localStorageMethod('get', 'squareSpaceSiteId');
  const refreshMatch = reduxFilteredLocationsData?.find(
    (location) =>
      location?.name === localStorageSeoId && location?.temp !== true
  );
  const [selectedAddress, setSelectedAddress]: any = useState(
    //refreshMatch || match || reduxFilteredLocationsData?.[0] || ''
    ''
  );

  // useEffect to set when redux data arrives
  useEffect(() => {
    if (!reduxFilteredLocationsData || reduxFilteredLocationsData?.length === 0)
      return;

    const refreshMatch = reduxFilteredLocationsData?.find(
      (location) =>
        location?.name === localStorageSeoId && location?.temp !== true
    );

    setSelectedAddress(
      refreshMatch || match || reduxFilteredLocationsData?.[0] || ''
    );
  }, [reduxFilteredLocationsData, localStorageSeoId, match]); // run when any of these change
  const [showBuyLocalSeoSlot, setShowBuyLocalSeoSlot] = useState(null);
  let selectedLocationId: any = useSelector(
    (state: RootState) => state.localSeo.selectedLocationId
  );
  const cleanedLocationId = selectedLocationId?.replace('locations/', '');
  let selectedAccountId: any = useSelector(
    (state: RootState) => state.localSeo.selectedAccountId
  );
  let locationsDetailsLoader =
    useSelector((state: RootState) => state.localSeo.locationsDetailsLoader) ??
    null;

  // Fetch the selected task title from Redux store
  const selectedLocalSeoTask: any =
    useSelector((state: RootState) => state.localSeo.selectedLocalSeoTask) ??
    null;
  let activePlanName = useSelector((state: RootState) => state.user.activePlan);
  let planDetails = useSelector((state: RootState) => state.user.planDetails);
  const isAgency =
    activePlanName === planDetails?.agency ||
    activePlanName === planDetails?.expertPlus ||
    activePlanName === planDetails.enterprise;
  let selectedBusinessAccountId: any = useSelector(
    (state: RootState) => state.localSeo.selectedBusinessAccountId
  );
  const isLocalSeo = isLocalSeoUser();
  const isLocalSeoUnlocked =
    useSelector((state: RootState) => state.localSeo.isLocalSeoUnlocked) ||
    isLocalSeo ||
    false;
  const isAgencyUpgrade =
    useSelector((state: RootState) => state.keywordResearch.isAgencyUpgrade) ??
    false;
  const locationListResponse =
    useSelector((state: RootState) => state.localSeo.locationListResponse) ??
    false;
  const handleChange = (event: React.SyntheticEvent, newValue: any) => {
    setValue(newValue);
  };
  let stripeSubscriptionDetails = useSelector(
    (state: RootState) => state.user.subscription
  );
  let isPremiumUser = useSelector((state: RootState) => state.user.premiumUser);
  const stripeLoader =
    useSelector((state: RootState) => state.siteAudit.stripeLoader) ?? true;
  let userDetails: any =
    useSelector((state: RootState) => state.counter.userDetails) ?? {};
  // Check if the site audit loader is active
  const isFreePlan = activePlanName === planDetails.free;
  const isNoPlanAccount =
    !stripeLoader &&
    !loaderRedux &&
    userDetails?.email &&
    userDetails?.temp == true &&
    (!stripeSubscriptionDetails?.subscription_id || !isPremiumUser);
  const isExpireAccount =
    !stripeLoader &&
    !loaderRedux &&
    !isFreePlan &&
    userDetails?.email &&
    userDetails?.temp !== true &&
    (!stripeSubscriptionDetails?.subscription_id || !isPremiumUser);

  const isNoPlanOrExpire = isNoPlanAccount || isExpireAccount;
  const isPause =
    stripeSubscriptionDetails &&
    stripeSubscriptionDetails?.pause_collection?.behavior;
  const isNotPause =
    stripeSubscriptionDetails &&
    !stripeSubscriptionDetails?.pause_collection?.behavior;
  const isEnterprise = activePlanName === planDetails?.enterprise;
  const { isChromeBrowser } = useBrowserType();
  const { NotAChromeBrowserBanner } = useChromeBrowserBanner();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const businessRef = useRef(null);
  const open = Boolean(anchorEl);
  const locationStoredId = getLocalSeoId();
  const locationStoredBusinessId = getLocalSeoBusinessId();
  const cleanedStoredLocationId = locationStoredId?.replace('locations/', '');
  const getLocalSeoCookieSqsp = getCookie(localseoSignupSqspFlow) ?? null;
  const isLocalSeoSqsp = getLocalSeoCookieSqsp === localSeoSignupSourceSqsp;


  const seoSpaceChannel = new BroadcastChannel('SEO_Space');
  seoSpaceChannel.onmessage = (event) => {
    if (event?.data?.type === 'gbpc_auth_connection') {
      dispatch(setSelectedBusinessAccountId(event?.data?.accountId));
      setGoogleAuth(event.data);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!locationsData) {
        await getLocationsDetails();
      }
    };

    fetchData();
    getCredits();
  }, []);

  useEffect(() => {
    if (
      (selectedAccountId && selectedLocationId) ||
      (locationStoredId && locationStoredBusinessId)
    ) {
      handleLocalSeoTasks();
    } else if (
      ((!selectedAccountId && !selectedLocationId) ||
        (!locationStoredId && !locationStoredBusinessId)) &&
      isLocalSeoSqsp
    ) {
      getLocationsDetails();
    }
  }, [selectedAccountId, selectedLocationId]);

  useEffect(() => {
    if (
      googleAuthText?.message &&
      googleAuthText?.success &&
      location.pathname == paths?.localTasks &&
      selectedBusinessAccountId
    ) {
      dispatch(setIsConnectionFlow(true));
      dispatch(setLocalSeoSection(1));
      navigate(paths?.localChecker);
      // Clear the authentication message after 5 seconds
      setTimeout(() => {
        setGoogleAuth(null);
      }, 5000);
    }
  }, [googleAuthText]);

  const handleTaskNavigation = (selectedTask) => {
    dispatch(setSelectedLocalSeoTask(selectedTask));
    setOpenTask(true);
  };

  const handleSelect = (locationObj) => {
    setSelectedAddress(locationObj); // store the full object
    dispatch(setSelectedBusinessNameFilter(locationObj?.title));
    dispatch(setSelectedBusinessName(locationObj?.title));
    const matchedName = locationObj?.name || null;
    const matchedAccountId = locationObj?.accountId || null;
    setLocalSeoId(matchedName);
    setLocalSeoBusinessId(matchedAccountId);
    dispatch(setSelectedLocationId(matchedName));
    dispatch(setSelectedAccountId(matchedAccountId));

    const cleanedId = matchedName?.replace('locations/', '');
    setAnchorEl(null);
  };

  const breadcrumbs = [
    <Typography
      sx={keywordResearchDashBoardCss?.breadCrumbLightText}
      key="1"
      onClick={() => {
        navigate(paths?.otherTools);
      }}
    >
      {localSeoTexts?.localSeo}
    </Typography>,
    <Typography key="2" sx={keywordResearchDashBoardCss?.breadCrumbText}>
      {localSeoTexts?.localSEOTasks}
    </Typography>
  ];

  const breadcrumbsLocalSeoTask = [
    <Typography
      sx={keywordResearchDashBoardCss?.breadCrumbLightText}
      key="1"
      onClick={() => {
        navigate(paths?.otherTools);
      }}
    >
      {localSeoTexts?.localSeo}
    </Typography>,
    <Typography
      sx={keywordResearchDashBoardCss?.breadCrumbLightText}
      key="2"
      onClick={() => {
        setOpenTask(false);
      }}
    >
      {localSeoTexts?.localSEOTasks}
    </Typography>,
    <Typography key="3" sx={keywordResearchDashBoardCss?.breadCrumbText}>
      {selectedLocalSeoTask?.title || ''}
    </Typography>
  ];

  const getLocationsDetails = async (isConnecting = false) => {
    dispatch(setLocationsDetailsLoader(true));

    const squareSpaceSiteId = localStorageMethod('get', 'squareSpaceSiteId');
    const payload = {
      isConnecting,
      squareSpaceSiteId: squareSpaceSiteId ? squareSpaceSiteId : null
    };
    const getLocationsResponse: any = await getLocations(payload);
    dispatch(setLocationListResponse(getLocationsResponse));
    if (
      getLocationsResponse?.status == 'success' &&
      getLocationsResponse?.isGBPConnected
    ) {
      const locations = getLocationsResponse?.locations || [];
      // Filter only locations with selected === true
      const selectedLocations =
        locations?.filter(
          (location) => location?.selected === true && location?.temp !== true
        ) || [];

      // Dispatch filtered data to Redux
      dispatch(setReduxFilteredLocationsData(selectedLocations));
      dispatch(setReduxLocationsData(selectedLocations));
      dispatch(setSelectedBusinessName(selectedLocations[0]?.title));
      const locationStorageId = getLocalSeoId();
      const locationStorageBusinessId = getLocalSeoBusinessId();
      dispatch(
        setSelectedLocationId(
          locationStorageId ? locationStorageId : selectedLocations[0]?.name
        )
      );
      dispatch(
        setSelectedAccountId(
          locationStorageBusinessId
            ? locationStorageBusinessId
            : selectedLocations[0]?.accountId
        )
      );
      if (!locationStorageId && !locationStorageBusinessId) {
        setLocalSeoId(selectedLocations[0]?.name);
        setLocalSeoBusinessId(selectedLocations[0]?.accountId);
      }
      // Extract just the title values and dispatch
      const businessNames = locations?.map((loc) => loc?.title).filter(Boolean); // remove null/undefined
      dispatch(setBusinessNamesData(businessNames));
      if (isConnecting) {
        dispatch(setLocalSeoSection(1));
        navigate(paths?.localChecker);
      }
    } else {
      if (isConnecting) {
        dispatch(setLocalSeoSection(1));
        navigate(paths?.localChecker);
      }
    }
    dispatch(setLocationsDetailsLoader(null));
  };

  const handleSnackBarClose = () => {
    setGoogleAuth(null);
  };

  const handleLocalSeoTasks = async (isMarkAsDone = null) => {
    setLoader(true);
    setOpenTask(false);
    let payload;
    if (isMarkAsDone) {
      payload = {
        accountId: selectedAccountId ?? locationStoredBusinessId,
        locationId: cleanedLocationId ?? cleanedStoredLocationId,
        taskId: selectedLocalSeoTask?.taskId,
        //status: selectedLocalSeoTask?.taskStatus
        status: 'completed',
        squareSpaceSiteId: squareSpaceSiteId ?? null
      };
    } else {
      payload = {
        accountId: selectedAccountId ?? locationStoredBusinessId,
        locationId: cleanedLocationId ?? cleanedStoredLocationId,
        squareSpaceSiteId: squareSpaceSiteId ?? null
      };
    }

    const localSeoTasksResponse: any = await localSeoTasks(payload);
    setSnackBarData(localSeoTasksResponse);
    if (localSeoTasksResponse?.status === 'success') {
      const updatedTask: any = localSeoTasksResponse?.task || {};
      const tasks = isMarkAsDone
        ? allTasks?.map((task) =>
            task.taskId === updatedTask?.taskId ? updatedTask : task
          )
        : localSeoTasksResponse?.tasks;
      setAllTasks(allTasks?.length > 0 ? tasks : localSeoTasksResponse?.tasks);
      const criticalTasks = tasks?.filter(
        (task) => task.priority === 'critical'
      );

      const recommendedTasks = tasks?.filter(
        (task) => task.priority === 'recommended'
      );

      const optionalTasks = tasks?.filter(
        (task) => task.priority === 'optional'
      );

      const completedTasks = tasks?.filter(
        (task) => task.priority === 'completed'
      );

      setCriticalSuggestions(criticalTasks);
      setRecommendedSuggestions(recommendedTasks);
      setOptionalSuggestions(optionalTasks);
      setCompletedSuggestions(completedTasks);
      setCriticalCount(criticalTasks?.length || 0);
      setRecommendedCount(recommendedTasks?.length || 0);
      setOptionalCount(optionalTasks?.length || 0);
      setCompletedCount(completedTasks?.length || 0);
      const countCalculation =
        (criticalTasks?.length || 0) +
        (recommendedTasks?.length || 0) +
        (optionalTasks?.length || 0) +
        (completedTasks?.length || 0);
      setTotalCount(countCalculation);
      const progress =
        Number(completedTasks?.length / countCalculation) * 100 || 0;
      setCountProgress(progress);
    }
    setTimeout(() => {
      setSnackBarData(null);
    }, 3000);
    setLoader(null);
  };

  const getCredits = async () => {
    setCreditLoader(true);
    let getSearchesDetail: any = await getCreditDetails();
    if (getSearchesDetail) {
      updateSearchesDetailsAndLimits(getSearchesDetail);
    }
    setCreditLoader(false);
  };
  const handleCloseSnackBar = () => {
    dispatch(setIsAgencyUpgrade(false));
  };

  const handleCloseTaskSnackBar = () => {
    setSnackBarData(null);
  };
  return (
    <>
      <Helmet>
        <title>
          {isLocalSeo
            ? `${SEOSpaceLocal} | Local SEO Tasks`
            : localSeoTexts.localSeoTaskHelmetText}
        </title>
      </Helmet>
      {snackBarData?.status && reduxFilteredLocationsData && (
        <Snackbar
          sx={{ marginTop: '2.8rem' }}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          open={snackBarData?.status}
          autoHideDuration={3000}
          onClose={handleCloseTaskSnackBar}
        >
          <Box>
            <Alert
              icon={
                snackBarData?.status === 'success' ? (
                  <img
                    draggable={false}
                    src={
                      process.env.PUBLIC_URL +
                      `/static/images/icons/checkIcon.svg`
                    }
                    style={{
                      width: '40px',
                      height: '27px'
                    }}
                  />
                ) : undefined // fallback to default icon
              }
              onClose={handleCloseTaskSnackBar}
              severity={snackBarData?.status}
              variant="filled"
              sx={{
                ...(snackBarData?.status === 'success'
                  ? snackBar?.alert
                  : snackBar?.alertError),
                backgroundColor:
                  snackBarData?.status === 'success'
                    ? 'var(--color-success-bg-ultra)'
                    : 'var(--color-error-bg)',
                border:
                  snackBarData?.status === 'success'
                    ? '1px solid var(--color-success-border)'
                    : '1px solid var(--color-error-red)',
                maxWidth: '667px'
              }}
            >
              {snackBarData?.message}
            </Alert>
          </Box>
        </Snackbar>
      )}
      {isAgencyUpgrade && (
        <Snackbar
          sx={{ marginTop: '2.8rem' }}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          open={isAgencyUpgrade}
          autoHideDuration={5000}
          onClose={handleCloseSnackBar}
        >
          <Box>
            <Alert
              icon={
                <img
                  draggable={false}
                  src={
                    process.env.PUBLIC_URL +
                    `/static/images/icons/checkIcon.svg`
                  }
                  style={{
                    width: '40px',
                    height: '27px'
                  }}
                />
              }
              onClose={handleCloseSnackBar}
              severity="success"
              variant="filled"
              sx={{
                ...snackBar?.alert,
                backgroundColor: 'var(--color-success-bg-ultra)',
                border: '1px solid var(--color-success-border)',
                maxWidth: '667px'
              }}
            >
              {KeywordTrackingAllTexts?.upgradeSuccessMessage}
            </Alert>
          </Box>
        </Snackbar>
      )}
      {googleAuthText?.message && (
        <Snackbar
          sx={{ marginTop: '2.8rem' }}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          open={googleAuthText?.message}
          autoHideDuration={5000}
          onClose={handleSnackBarClose}
        >
          <Box>
            <Alert
              icon={
                <img
                  draggable={false}
                  src={
                    process.env.PUBLIC_URL +
                    `/static/images/icons/checkIcon.svg`
                  }
                  style={{
                    width: '40px',
                    height: '27px'
                  }}
                />
              }
              onClose={handleSnackBarClose}
              severity="success"
              variant="filled"
              sx={{
                ...snackBar?.alert,
                backgroundColor: 'var(--color-success-bg-ultra)',
                border: '1px solid var(--color-success-border)',
                maxWidth: '667px'
              }}
            >
              {googleAuthText?.message}
            </Alert>
          </Box>
        </Snackbar>
      )}
      {!isLocalSeo && NotAChromeBrowserBanner}

      {isChromeBrowser &&
        !isNoPlanOrExpire &&
        !isFreePlan &&
        isNotPause &&
        !isLocalSeo && (
          <>
            <NewCommonChromeExtensionModal />
          </>
        )}
      <Box sx={keywordOverviewCss?.breadcrumbsMainBoxNew}>
        <Box>
          <Breadcrumbs
            separator={
              <NavigateNextIcon
                fontSize="small"
                sx={keywordResearchDashBoardCss?.navigateNextIcon}
              />
            }
            aria-label="breadcrumb"
          >
            {openTask ? breadcrumbsLocalSeoTask : breadcrumbs}
          </Breadcrumbs>
        </Box>
        <Box sx={keywordOverviewCss?.userTutorialBox}>
          <img
            onClick={() => {
              openNewTab(keywordOverviewTexts?.keywordResearchTutorialsLink);
            }}
            src={
              process.env.PUBLIC_URL +
              `/static/images/icons/keyword/book-open-02.svg`
            }
            alt="icon"
          />
          <Typography
            onClick={() => {
              openNewTab(GMBTutorialLinks?.localSeoTutorial);
            }}
            sx={keywordOverviewCss?.userTutorial}
          >
            {localSeoTexts?.tutorialText}
          </Typography>
        </Box>
      </Box>
      {locationsDetailsLoader || loader || creditLoader ? (
        <LocalSeoCommonLoader />
      ) : (
        <>
          {openTask && (isAgency || isLocalSeoUnlocked) ? (
            <SelectedLocalSeoTask handleLocalSeoTasks={handleLocalSeoTasks} />
          ) : (isAgency || isLocalSeoUnlocked) &&
            reduxFilteredLocationsData?.length === 0 &&
            reduxFilteredLocationsData ? (
            <ConnectBusinessProfileModal />
          ) : (isAgency || isLocalSeoUnlocked) && reduxFilteredLocationsData ? (
            <Card sx={keywordOverviewCss?.card}>
              <CardContent sx={keywordOverviewCss?.cardContent}>
                <Box
                  sx={{
                    display: 'flex',
                    gap: '8px',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: 'Inter',
                      fontWeight: 700,
                      fontSize: 'var(--font-size-30)',
                      lineHeight: 'var(--line-height-38)',
                      color: 'var(--color-primary)'
                    }}
                  >
                    {'Local SEO Tasks'}
                  </Typography>

                  <BusinessProfileSelector
                    selectedAddress={selectedAddress}
                    locations={reduxFilteredLocationsData}
                    isEnterprise={isEnterprise}
                    enterpriseLimit={enterpriseDropdownBusinessesLimit}
                    onSelect={handleSelect}
                    onAddProfile={() => {
                      if (locationListResponse?.limitExceeded) {
                        setShowBuyLocalSeoSlot(true);
                      } else {
                        openNewTab(paths?.googleBusiness);
                      }
                    }}
                    onViewAll={() => {
                      navigate(paths?.localSeoBusinessListRoute);
                    }}
                  />
                </Box>
                <Typography sx={LocalSeoAllSx?.localSeoTaskDescSx}>
                  {localSeoTexts?.localSeoTaskDesc}
                </Typography>
                <Box>
                  <LocalSeoProgress
                    completedCount={completedCount}
                    totalCount={totalCount}
                    countProgress={countProgress}
                  />
                </Box>
                <Box mt={3}>
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="SEO Task filter"
                    sx={{
                      ...taskListCSS?.tabCSS,
                      display: 'flex',
                      borderBottom: 1,
                      borderColor: 'divider'
                    }}
                  >
                    {criticalCount > 0 && (
                      <Tab
                        value="critical"
                        label={
                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Typography
                              sx={
                                value == 'critical'
                                  ? taskListCSS?.tabSelectedLabelSx
                                  : taskListCSS?.tabNotSelectedLabelSx
                              }
                            >
                              Critical
                            </Typography>
                            <Chip
                              label={criticalCount}
                              size="small"
                              sx={taskListCSS?.chipCritical}
                            />
                          </Box>
                        }
                        sx={{ flexGrow: 1, maxWidth: '170px' }}
                      />
                    )}
                    {recommendedCount > 0 && (
                      <Tab
                        value="recommended"
                        label={
                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Typography
                              sx={
                                value == 'recommended'
                                  ? taskListCSS?.tabSelectedLabelSx
                                  : taskListCSS?.tabNotSelectedLabelSx
                              }
                            >
                              Recommended
                            </Typography>
                            <Chip
                              label={recommendedCount}
                              size="small"
                              color="error"
                              sx={taskListCSS?.chipRecommended}
                            />
                          </Box>
                        }
                        sx={{ flexGrow: 1, maxWidth: '170px' }}
                      />
                    )}
                    {optionalCount > 0 && (
                      <Tab
                        value="optional"
                        label={
                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Typography
                              sx={
                                value == 'optional'
                                  ? taskListCSS?.tabSelectedLabelSx
                                  : taskListCSS?.tabNotSelectedLabelSx
                              }
                            >
                              Optional
                            </Typography>
                            <Chip
                              label={optionalCount}
                              size="small"
                              sx={taskListCSS?.chipOptional}
                            />
                          </Box>
                        }
                        sx={{ flexGrow: 1, maxWidth: '170px' }}
                      />
                    )}
                    {completedCount > 0 && (
                      <Tab
                        value="completed"
                        label={
                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Typography
                              sx={
                                value == 'completed'
                                  ? taskListCSS?.tabSelectedLabelSx
                                  : taskListCSS?.tabNotSelectedLabelSx
                              }
                            >
                              Completed
                            </Typography>
                            <Chip
                              label={completedCount}
                              size="small"
                              sx={taskListCSS?.chipCompleted}
                            />
                          </Box>
                        }
                        sx={{ flexGrow: 1, maxWidth: '170px' }}
                      />
                    )}
                  </Tabs>
                  <Box sx={{ marginTop: '32px' }}>
                    {value == 'critical' &&
                      criticalSuggestions?.map((text, idx) => (
                        <Box
                          key={idx}
                          sx={{
                            borderRadius: '6px',
                            padding: '16px',
                            border: '1px solid var(--color-bg-purple-tint)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            marginBottom: '12px',
                            '&:hover': {
                              backgroundColor: 'var(--color-bg-purple-tint)'
                            },
                            cursor: 'pointer'
                          }}
                          onClick={() => {
                            handleTaskNavigation(text);
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '12px'
                            }}
                          >
                            <img
                              src="/static/images/icons/local-seo/alert-circle.svg"
                              alt="SEOSpace"
                            />
                            <Typography
                              sx={{
                                fontFamily: 'Inter',
                                fontWeight: 400,
                                fontSize: 'var(--font-size-14)',
                                lineHeight: 'var(--line-height-20)',
                                color: 'var(--color-primary)'
                              }}
                            >
                              {text?.title}
                            </Typography>
                          </Box>
                          <ArrowForwardIosIcon
                            fontSize="small"
                            sx={{
                              color: 'var(--color-primary)',
                              cursor: 'pointer',
                              ...keywordResearchDashBoardCss?.arrowForwardIcon
                            }}
                            onClick={() => {
                              handleTaskNavigation(text);
                            }}
                          />
                        </Box>
                      ))}
                    {value == 'recommended' &&
                      recommendedSuggestions?.map((text, idx) => (
                        <Box
                          key={idx}
                          sx={{
                            borderRadius: '6px',
                            padding: '16px',
                            border: '1px solid var(--color-bg-purple-tint)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            marginBottom: '12px', // spacing between boxes
                            '&:hover': {
                              backgroundColor: 'var(--color-bg-purple-tint)'
                            },
                            cursor: 'pointer'
                          }}
                          onClick={() => {
                            handleTaskNavigation(text);
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '12px'
                            }}
                          >
                            <img
                              src="/static/images/icons/local-seo/flash-circle.svg"
                              alt="SEOSpace"
                            />
                            <Typography
                              sx={{
                                fontFamily: 'Inter',
                                fontWeight: 400,
                                fontSize: 'var(--font-size-14)',
                                lineHeight: 'var(--line-height-20)',
                                color: 'var(--color-primary)'
                              }}
                            >
                              {text?.title}
                            </Typography>
                          </Box>
                          <ArrowForwardIosIcon
                            fontSize="small"
                            sx={{
                              color: 'var(--color-primary)',
                              cursor: 'pointer',
                              ...keywordResearchDashBoardCss?.arrowForwardIcon
                            }}
                            onClick={() => {
                              handleTaskNavigation(text);
                            }}
                          />
                        </Box>
                      ))}
                    {value == 'optional' &&
                      optionalSuggestions?.map((text, idx) => (
                        <Box
                          key={idx}
                          sx={{
                            borderRadius: '6px',
                            padding: '16px',
                            border: '1px solid var(--color-bg-purple-tint)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            marginBottom: '12px', // spacing between boxes
                            '&:hover': {
                              backgroundColor: 'var(--color-bg-purple-tint)'
                            },
                            cursor: 'pointer'
                          }}
                          onClick={() => {
                            handleTaskNavigation(text);
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '12px'
                            }}
                          >
                            <img
                              src="/static/images/icons/optional.svg"
                              alt="SEOSpace"
                            />
                            <Typography
                              sx={{
                                fontFamily: 'Inter',
                                fontWeight: 400,
                                fontSize: 'var(--font-size-14)',
                                lineHeight: 'var(--line-height-20)',
                                color: 'var(--color-primary)'
                              }}
                            >
                              {text?.title}
                            </Typography>
                          </Box>
                          <ArrowForwardIosIcon
                            fontSize="small"
                            sx={{
                              color: 'var(--color-primary)',
                              cursor: 'pointer',
                              ...keywordResearchDashBoardCss?.arrowForwardIcon
                            }}
                            onClick={() => {
                              handleTaskNavigation(text);
                            }}
                          />
                        </Box>
                      ))}
                    {value == 'completed' &&
                      completedSuggestions?.map((text, idx) => (
                        <Box
                          key={idx}
                          sx={{
                            borderRadius: '6px',
                            padding: '16px',
                            border: '1px solid var(--color-bg-purple-tint)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            marginBottom: '12px', // spacing between boxes
                            '&:hover': {
                              backgroundColor: 'var(--color-bg-purple-tint)'
                            },
                            cursor: 'pointer'
                          }}
                          onClick={() => {
                            handleTaskNavigation(text);
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '12px'
                            }}
                          >
                            <img
                              src="/static/images/icons/local-seo/green-circle.svg"
                              alt="SEOSpace"
                              width={24}
                              height={24}
                            />
                            <Typography
                              sx={{
                                fontFamily: 'Inter',
                                fontWeight: 400,
                                fontSize: 'var(--font-size-14)',
                                lineHeight: 'var(--line-height-20)',
                                color: 'var(--color-primary)'
                              }}
                            >
                              {text?.title}
                            </Typography>
                          </Box>
                          <ArrowForwardIosIcon
                            fontSize="small"
                            sx={{
                              color: 'var(--color-primary)',
                              cursor: 'pointer',
                              ...keywordResearchDashBoardCss?.arrowForwardIcon
                            }}
                            onClick={() => {
                              handleTaskNavigation(text);
                            }}
                          />
                        </Box>
                      ))}
                  </Box>
                </Box>
              </CardContent>
            </Card>
          ) : (isAgency || isLocalSeoUnlocked) &&
            (!locationsData || !reduxFilteredLocationsData) ? (
            <ConnectBusinessProfileModal />
          ) : !isAgency && !isLocalSeoUnlocked && activePlanName ? (
            <Card sx={{ ...keywordOverviewCss?.card }}>
              <CardContent sx={keywordOverviewCss?.cardContent}>
                <UpgradeToAgency isLocalSeo={true} isLocalSeoTask={true} />
              </CardContent>
            </Card>
          ) : (
            <LocalSeoCommonLoader />
          )}
        </>
      )}
      {/* Footer Spacer */}
      <Box className="h-10"></Box>
      {showBuyLocalSeoSlot && (
        <BuySlotsCommonModal
          triggerOpen={true}
          onClose={() => setShowBuyLocalSeoSlot(false)}
          isLocalSeo={true}
        />
      )}
    </>
  );
};
